<template lang="html">
  <!-- <v-card dark>
    <v-card-title>
      <span class="headline"><strong>Trademarks</strong></span>
    </v-card-title>

    <v-card-text style="text-align: left;">
      <p>King Show Games Trademarks</p>

      <p>The following is a non-exhaustive list of King Show Games, Inc.’s trademarks. &nbsp;While you may accurately refer to King Show Games products using the accurate trademark or name, King Show Games trademarks may not be used except with our prior written permission.</p>

      <p>The absence of a product or service name or logo from this list does not constitute a waiver of King Show Games, Inc.’s trademark or other intellectual property rights concerning that name or logo.</p>

      <h2>Trademark</h2>
      <hr>
      <ul>
        <li>$uper Rich Re-Spins&reg;</li>
        <li>7 Leagues Under the Sea&reg;</li>
        <li>Amazon Goddess&reg;</li>
        <li>Back To Back&reg;</li>
        <li>Berry Cherry&reg;</li>
        <li>Big 5 Safari&reg;</li>
        <li>Black Stallion&reg;</li>
        <li>Blackout Jackpot&reg;</li>
        <li>Ca$h Ca$h Ca$h&reg;</li>
        <li>Cloud 9&reg;</li>
        <li>Combo Draw Poker&reg;</li>
        <li>Dark &amp; Stormy&reg;</li>
        <li>Diamond City&reg;</li>
        <li>Dolphin Bay&reg;</li>
        <li>Double Draw Double Pay&reg;</li>
        <li>Double Symbols&reg;</li>
        <li>Exotic Island&reg;</li>
        <li>Extra Hot&reg;</li>
        <li>Extra Life&reg;</li>
        <li>Fairy Ring&reg;</li>
        <li>Farmer’s Daughter&reg;</li>
        <li>Fire Pearl&reg;</li>
        <li>Fish On!&reg;</li>
        <li>Fish On! Big Bass&reg;</li>
        <li>Fishing Bob&reg;</li>
        <li>Fortune Trader&reg;</li>
        <li>Gazillionaire&reg;</li>
        <li>Golden Dice&reg;</li>
        <li>Greek Goddess&reg;</li>
        <li>Hinge Wilds&reg;</li>
        <li>Hot Poker Dice&reg;</li>
        <li>Hot Roll&reg;</li>
        <li>Hot Roll Community&reg;</li>
        <li>Hot Roll Golden Dice Progressives&reg;</li>
        <li>Hot Roulette&reg;</li>
        <li>Jade Fortune&reg;</li>
        <li>King Reels&reg;</li>
        <li>King Show Games&reg;</li>
        <li>King Stacks&reg;</li>
        <li>Koala Cove&reg;</li>
        <li>Legend of Chang'e&reg;</li>
        <li>Legends of Asgard&reg;</li>
        <li>Leopard Lagoon&reg;</li>
        <li>Luck of the Lemur&reg;</li>
        <li>Lucky Buddha&reg;</li>
        <li>Lucky Hot 7s&reg;</li>
        <li>Lucky Stud-Draw&reg;</li>
        <li>Lulu &amp; Luigi&reg;</li>
        <li>Major Catch&reg;</li>
        <li>Mammoth Reels&reg;</li>
        <li>Mega Free Games&reg;</li>
        <li>Mega Hot&reg;</li>
        <li>Mega Marlin&reg;</li>
        <li>Minor Catch&reg;</li>
        <li>Monster Catch&reg;</li>
        <li>Movin’ On Up&reg;</li>
        <li>Mystery of the Congo&reg;</li>
        <li>Mystery Win Multiplier&reg;</li>
        <li>Panda Park&reg;</li>
        <li>Polar Bear Seas&reg;</li>
        <li>Prince of Thieves&reg;</li>
        <li>Puppy Stampede&reg;</li>
        <li>Pyramid Poker&reg;</li>
        <li>Rocket City Bonanza&reg;</li>
        <li>Sakura Tree&reg;</li>
        <li>Snow Day!&reg;</li>
        <li>Split Card&reg;</li>
        <li>Super Rich&reg;</li>
        <li>The Great and Wonderful Polar Bear&reg;</li>
        <li>Triple Big Wheel&reg;</li>
        <li>Triple Draw Triple Pay&reg;</li>
        <li>Turquoise Princess&reg;</li>
        <li>Turtle Coast&reg;</li>
        <li>VIP&reg;</li>
        <li>Waterfall Multipliers&reg;</li>
      </ul>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="orange darken-1" flat="flat" @click="okClicked">OK</v-btn>
    </v-card-actions>
  </v-card> -->
  <v-container justify-center wrap fluid class="trademarks-container">
    <v-layout justify-center wrap>
      <v-flex xs12 sm10 md8>
        <h1 class="trademarks-title">Trademarks</h1>

        <!-- <v-flex mt-4>
          <p class="text-xs-left body-text">Over our 20 year history we have trademarked many games and feature names.</p>
        </v-flex> -->

        <v-flex mt-4>
          <p class="text-xs-left body-text">The following is a non-exhaustive list of King Show Games, Inc.'s trademarks. &nbsp;While you may accurately refer to King Show Games products using the accurate trademark or name, King Show Games trademarks may not be used except with our prior written permission.
          <br>
          The absence of a product or service name or logo from this list does not constitute a waiver of King Show Games, Inc.'s trademark or other intellectual property rights concerning that name or logo.
          </p>
        </v-flex>

        <!-- <v-flex mt-4>
          <p class="text-xs-left body-text">The absence of a product or service name or logo from this list does not constitute a waiver of King Show Games, Inc.'s trademark or other intellectual property rights concerning that name or logo.</p>
        </v-flex> -->

        <v-flex xs12 mt-3>
          <h2 class="trademarks-body-title text-xs-left"><strong>List of Trademarks</strong></h2>
          <hr>
        </v-flex>

        <v-layout row wrap align-start justify-start class="trademarks-body-list" mt-2>
          <v-flex xs12 sm6 md4 lg4>
            <div class="trademarks-body-align">$uper Rich Re-Spins&reg;</div>
            <div class="trademarks-body-align">3 Sacred Treasures&reg;</div>
            <div class="trademarks-body-align">5 Card Plus 2&reg;</div>
            <div class="trademarks-body-align">6x4x3x2x V.I.P.&reg;</div>
            <div class="trademarks-body-align">7 Leagues Under the Sea&reg;</div>
            <div class="trademarks-body-align">888 Empress&reg;</div>
            <div class="trademarks-body-align">888 Panda&reg;</div>
            <div class="trademarks-body-align">888 Super Link&reg;</div>
            <div class="trademarks-body-align">Alaskan King&reg;</div>
            <div class="trademarks-body-align">Amazon Goddess&reg;</div>
            <div class="trademarks-body-align">Arctic Fire&reg;</div>
            <div class="trademarks-body-align">Astronomical Progressive&reg;</div>
            <div class="trademarks-body-align">Back To Back&reg;</div>
            <div class="trademarks-body-align">Balloon Bonus&reg;</div>
            <div class="trademarks-body-align">Bar Star&reg;</div>
            <div class="trademarks-body-align">Berry Cherry&reg;</div>
            <div class="trademarks-body-align">Big 5 Cats&reg;</div>
            <div class="trademarks-body-align">Big 5 Pharaohs&reg;</div>
            <div class="trademarks-body-align">Big 5 Progressives&reg;</div>
            <div class="trademarks-body-align">Big 5 Safari&reg;</div>
            <div class="trademarks-body-align">Big Action Billions&reg;</div>
            <div class="trademarks-body-align">Big Action Jackpots&reg;</div>
            <div class="trademarks-body-align">Big Winner!&reg;</div>
            <div class="trademarks-body-align">Birds of Beauty&reg;</div>
            <div class="trademarks-body-align">Black Stallion&reg;</div>
            <div class="trademarks-body-align">Blackout Jackpot&reg;</div>
            <div class="trademarks-body-align">Blazing Bingo&reg;</div>
            <div class="trademarks-body-align">Blazing Blackjack&reg;</div>
            <div class="trademarks-body-align">Blazing Roulette&reg;</div>
            <div class="trademarks-body-align">Block Wilds&reg;</div>
            <div class="trademarks-body-align">Bonus Wild Poker&reg;</div>
            <div class="trademarks-body-align">Boosted Big Wheel&reg;</div>
            <div class="trademarks-body-align">Bora Bora Breeze&reg;</div>
            <div class="trademarks-body-align">Buddha Riches&reg;</div>
            <div class="trademarks-body-align">Buffalo Riches&reg;</div>
            <div class="trademarks-body-align">Buffalo Storm&reg;</div>
            <div class="trademarks-body-align">Ca$h Ca$h Ca$h&reg;</div>
            <div class="trademarks-body-align">Caifu Zhi Wu&reg;</div>
            <div class="trademarks-body-align">Candy Castle&reg;</div>
            <div class="trademarks-body-align">Candy Riches&reg;</div>
            <div class="trademarks-body-align">Cash Blast&reg;</div>
            <div class="trademarks-body-align">Cash Cube&reg;</div>
            <div class="trademarks-body-align">Cat Peak&reg;</div>
            <div class="trademarks-body-align">Catch a Clown&reg;</div>
            <div class="trademarks-body-align">Cave of Wonders&reg;</div>
            <div class="trademarks-body-align">Celtic Magic&reg;</div>
            <div class="trademarks-body-align">Charging Multipliers&reg;</div>
            <div class="trademarks-body-align">Cherry Ca$h&reg;</div>
            <div class="trademarks-body-align">Classic Hits&reg;</div>
            <div class="trademarks-body-align">Cleopatra Vs. King Tut&reg;</div>
            <div class="trademarks-body-align">Cloud 9&reg;</div>
            <div class="trademarks-body-align">Colossal Cats&reg;</div>
            <div class="trademarks-body-align">Colossal Titans&reg;</div>
            <div class="trademarks-body-align">Combo Draw Poker&reg;</div>
            <div class="trademarks-body-align">Combo Reels&reg;</div>
            <div class="trademarks-body-align">Cosmic Progressive&reg;</div>
            <div class="trademarks-body-align">Countdown Wilds&reg;</div>
            <div class="trademarks-body-align">Country Club Cash&reg;</div>
            <div class="trademarks-body-align">Crashing Wilds&reg;</div>
            <div class="trademarks-body-align">Cube Reels&reg;</div>
            <div class="trademarks-body-align">Cupid Cuties&reg;</div>
            <div class="trademarks-body-align">Currency King&reg;</div>
            <div class="trademarks-body-align">Cyclone 7S&reg;</div>
            <div class="trademarks-body-align">Dark &amp; Stormy&reg;</div>
            <div class="trademarks-body-align">Delayed Expanding Wilds&reg;</div>
            <div class="trademarks-body-align">Desert Jewel&reg;</div>
            <div class="trademarks-body-align">Diamond Buffalo&reg;</div>
            <div class="trademarks-body-align">Diamond City&reg;</div>
            <div class="trademarks-body-align">Ding Slots Ding&reg;</div>
            <div class="trademarks-body-align">Dirty Sally's&reg;</div>
            <div class="trademarks-body-align">Dolphin Bay&reg;</div>
            <div class="trademarks-body-align">Double Big Wheel&reg;</div>
            <div class="trademarks-body-align">Double Draw Double Pay&reg;</div>
            <div class="trademarks-body-align">Double Mega Hot 7s&reg;</div>
            <div class="trademarks-body-align">Double Sapphires&reg;</div>
            <div class="trademarks-body-align">Double Spitfire 7S&reg;</div>
            <div class="trademarks-body-align">Double Symbols&reg;</div>
            <div class="trademarks-body-align">Dragon Storm&reg;</div>
            <div class="trademarks-body-align">Dragons Vs Pandas&reg;</div>
            <div class="trademarks-body-align">Drawmania&reg;</div>
            <div class="trademarks-body-align">Duck Shot&reg;</div>
            <div class="trademarks-body-align">Egypt Free Games&reg;</div>
            <div class="trademarks-body-align">Elephants Vs Tigers&reg;</div>
            <div class="trademarks-body-align">Empress of Egypt&reg;</div>
            <div class="trademarks-body-align">Empress of the Pharaohs&reg;</div>
            <div class="trademarks-body-align">Empress Treasure Tracker&reg;</div>
            <div class="trademarks-body-align">Empress Vs Emperors&reg;</div>
            <div class="trademarks-body-align">Enchanted Tarot&reg;</div>
            <div class="trademarks-body-align">Exotic Island&reg;</div>
            <div class="trademarks-body-align">Extra Hot&reg;</div>
            <div class="trademarks-body-align">Extra Life&reg;</div>
            <div class="trademarks-body-align">Fairy Ring&reg;</div>
            <div class="trademarks-body-align">Fanrong Yu Caifu&reg;</div>
            <div class="trademarks-body-align">Farmer’s Daughter&reg;</div>
            <div class="trademarks-body-align">Feng Shui Dragon&reg;</div>
            <div class="trademarks-body-align">Fiery Wilds&reg;</div>
            <div class="trademarks-body-align">Filthy Rich&reg;</div>
            <div class="trademarks-body-align">Fire Chariot&reg;</div>
            <div class="trademarks-body-align">Fire Dancer&reg;</div>
            <div class="trademarks-body-align">Fire Pearl&reg;</div>
            <div class="trademarks-body-align">Firework Frenzy&reg;</div>
            <div class="trademarks-body-align">Fish On!&reg;</div>
            <div class="trademarks-body-align">Fish On! Big Bass&reg;</div>
            <div class="trademarks-body-align">Fishing Bob&reg;</div>
            <div class="trademarks-body-align">Flying Cash&reg;</div>
            <div class="trademarks-body-align">Flying Cash Vault&reg;</div>
          </v-flex>

          <v-flex xs12 sm6 md4 lg4>
            <div class="trademarks-body-align">Flying Cow&reg;</div>
            <div class="trademarks-body-align">Forest Quest&reg;</div>
            <div class="trademarks-body-align">Fortune Trader&reg;</div>
            <div class="trademarks-body-align">Freddy the Lawn Flamingo&reg;</div>
            <div class="trademarks-body-align">Fruit Riches&reg;</div>
            <div class="trademarks-body-align">Fu Ren Wu&reg;</div>
            <div class="trademarks-body-align">Fuse Blast&reg;</div>
            <div class="trademarks-body-align">Galactic Free Games&reg;</div>
            <div class="trademarks-body-align">Game Time&reg;</div>
            <div class="trademarks-body-align">Gazillionaire&reg;</div>
            <div class="trademarks-body-align">Gem Multipliers&reg;</div>
            <div class="trademarks-body-align">Ghost Island&reg;</div>
            <div class="trademarks-body-align">Giveaway Wheel&reg;</div>
            <div class="trademarks-body-align">Golden 12&reg;</div>
            <div class="trademarks-body-align">Golden Beauty&reg;</div>
            <div class="trademarks-body-align">Golden Dice&reg;</div>
            <div class="trademarks-body-align">Golden Empress&reg;</div>
            <div class="trademarks-body-align">Golden Forest&reg;</div>
            <div class="trademarks-body-align">Golden Realm&reg;</div>
            <div class="trademarks-body-align">Golden Rose&reg;</div>
            <div class="trademarks-body-align">Golden Staff&reg;</div>
            <div class="trademarks-body-align">Golden Throne&reg;</div>
            <div class="trademarks-body-align">Grand Gong&reg;</div>
            <div class="trademarks-body-align">Greek Goddess&reg;</div>
            <div class="trademarks-body-align">Green Diamond&reg;</div>
            <div class="trademarks-body-align">Gypsy Treasure&reg;</div>
            <div class="trademarks-body-align">Haunted Halloween&reg;</div>
            <div class="trademarks-body-align">High Noon Express&reg;</div>
            <div class="trademarks-body-align">Hinge Wilds&reg;</div>
            <div class="trademarks-body-align">Holy Guacamole!&reg;</div>
            <div class="trademarks-body-align">Hot Bingo&reg;</div>
            <div class="trademarks-body-align">Hot BJ&reg;</div>
            <div class="trademarks-body-align">Hot Blackjack&reg;</div>
            <div class="trademarks-body-align">Hot Fever 7S&reg;</div>
            <div class="trademarks-body-align">Hot Poker Dice&reg;</div>
            <div class="trademarks-body-align">Hot Roll&reg;</div>
            <div class="trademarks-body-align">Hot Roll Community&reg;</div>
            <div class="trademarks-body-align">Hot Roll Golden Dice Progressives&reg;</div>
            <div class="trademarks-body-align">Hot Roll Progressives&reg;</div>
            <div class="trademarks-body-align">Hot Roulette&reg;</div>
            <div class="trademarks-body-align">Hot X&reg;</div>
            <div class="trademarks-body-align">Huangjin Caifu&reg;</div>
            <div class="trademarks-body-align">It’s a Keeper&reg;</div>
            <div class="trademarks-body-align">Jade Fortune&reg;</div>
            <div class="trademarks-body-align">Jin Baozhak&reg;</div>
            <div class="trademarks-body-align">Jin Fengfu&reg;</div>
            <div class="trademarks-body-align">Jumping Wilds&reg;</div>
            <div class="trademarks-body-align">Jungle Wheel&reg;</div>
            <div class="trademarks-body-align">Kablast Cash&reg;</div>
            <div class="trademarks-body-align">King of the Pharaohs&reg;</div>
            <div class="trademarks-body-align">King Reels&reg;</div>
            <div class="trademarks-body-align">King Show Games&reg;</div>
            <div class="trademarks-body-align">King Stacks&reg;</div>
            <div class="trademarks-body-align">King's Keep&reg;</div>
            <div class="trademarks-body-align">Kings of Egypt&reg;</div>
            <div class="trademarks-body-align">Koala Cove&reg;</div>
            <div class="trademarks-body-align">KSG&reg;</div>
            <div class="trademarks-body-align">Lady and the Tiger&reg;</div>
            <div class="trademarks-body-align">Larry's Loot&reg;</div>
            <div class="trademarks-body-align">Latino Machino&reg;</div>
            <div class="trademarks-body-align">Legend of Chang'e&reg;</div>
            <div class="trademarks-body-align">Legendary Beauty&reg;</div>
            <div class="trademarks-body-align">Legends of Asgard&reg;</div>
            <div class="trademarks-body-align">Leopard Lagoon&reg;</div>
            <div class="trademarks-body-align">Life in the Fast Lane&reg;</div>
            <div class="trademarks-body-align">Lightning Goddess&reg;</div>
            <div class="trademarks-body-align">Linkmania&reg;</div>
            <div class="trademarks-body-align">Lion Kingdom&reg;</div>
            <div class="trademarks-body-align">Lost Garden&reg;</div>
            <div class="trademarks-body-align">Luck of the Lemur&reg;</div>
            <div class="trademarks-body-align">Lucky Buddha&reg;</div>
            <div class="trademarks-body-align">Lucky Hot 7s&reg;</div>
            <div class="trademarks-body-align">Lucky Stud-Draw&reg;</div>
            <div class="trademarks-body-align">Lucky Suit&reg;</div>
            <div class="trademarks-body-align">Lucky Suit Poker&reg;</div>
            <div class="trademarks-body-align">Lucky Wealth Cat&reg;</div>
            <div class="trademarks-body-align">Lucky Win Multiplier&reg;</div>
            <div class="trademarks-body-align">Lulu &amp; Luigi&reg;</div>
            <div class="trademarks-body-align">Madame Serena&reg;</div>
            <div class="trademarks-body-align">Major Catch&reg;</div>
            <div class="trademarks-body-align">Malibu&reg;</div>
            <div class="trademarks-body-align">Mammoth Reels&reg;</div>
            <div class="trademarks-body-align">Mas Margaritas&reg;</div>
            <div class="trademarks-body-align">Massive Ways&reg;</div>
            <div class="trademarks-body-align">Mega Free Games&reg;</div>
            <div class="trademarks-body-align">Mega Hot&reg;</div>
            <div class="trademarks-body-align">Mega Hot 7s&reg;</div>
            <div class="trademarks-body-align">Mega Marlin&reg;</div>
            <div class="trademarks-body-align">Minnow Catch&reg;</div>
            <div class="trademarks-body-align">Minor Catch&reg;</div>
            <div class="trademarks-body-align">Mistress of the West&reg;</div>
            <div class="trademarks-body-align">Monster Catch&reg;</div>
            <div class="trademarks-body-align">Moonlit Forest&reg;</div>
            <div class="trademarks-body-align">Movin’ On Up&reg;</div>
            <div class="trademarks-body-align">Mummy's Treasure&reg;</div>
            <div class="trademarks-body-align">My Super Sweet Tooth&reg;</div>
            <div class="trademarks-body-align">Mystery Diamond&reg;</div>
            <div class="trademarks-body-align">Mystery Multipliers&reg;</div>
            <div class="trademarks-body-align">Mystery of the Clockwork&reg;</div>
            <div class="trademarks-body-align">Mystery of the Congo&reg;</div>
            <div class="trademarks-body-align">Mystery of the Dragon&reg;</div>
            <div class="trademarks-body-align">Mystery of the Pyramids&reg;</div>
            <div class="trademarks-body-align">Mystery Win Multiplier&reg;</div>
            <div class="trademarks-body-align">Mystical Gold&reg;</div>
            <div class="trademarks-body-align">Mystical Riches&reg;</div>
          </v-flex>

          <v-flex xs12 sm6 md4 lg4>
            <div class="trademarks-body-align">Oracle Free Games&reg;</div>
            <div class="trademarks-body-align">Oystermania&reg;</div>
            <div class="trademarks-body-align">Panda Park&reg;</div>
            <div class="trademarks-body-align">Party Multipliers&reg;</div>
            <div class="trademarks-body-align">Pharaohs Free Games&reg;</div>
            <div class="trademarks-body-align">Pharaohs of the Nile&reg;</div>
            <div class="trademarks-body-align">Phone Tag&reg;</div>
            <div class="trademarks-body-align">Pick A Reel&reg;</div>
            <div class="trademarks-body-align">Pig and Pug&reg;</div>
            <div class="trademarks-body-align">Pinata Power&reg;</div>
            <div class="trademarks-body-align">Pinata Smash&reg;</div>
            <div class="trademarks-body-align">Pixie's Treasure&reg;</div>
            <div class="trademarks-body-align">Platinum Buffalo&reg;</div>
            <div class="trademarks-body-align">Poker Boost&reg;</div>
            <div class="trademarks-body-align">Pokermania&reg;</div>
            <div class="trademarks-body-align">Polar Bear Seas&reg;</div>
            <div class="trademarks-body-align">Power of Cash&reg;</div>
            <div class="trademarks-body-align">Power Up Multipliers&reg;</div>
            <div class="trademarks-body-align">Price Check&reg;</div>
            <div class="trademarks-body-align">Prince of Thieves&reg;</div>
            <div class="trademarks-body-align">Prosperity Buddha&reg;</div>
            <div class="trademarks-body-align">Puppy Stampede&reg;</div>
            <div class="trademarks-body-align">Pyramid Power&reg;</div>
            <div class="trademarks-body-align">Pyramid Poker&reg;</div>
            <div class="trademarks-body-align">Pyramid Progressives&reg;</div>
            <div class="trademarks-body-align">Pyramid Queen&reg;</div>
            <div class="trademarks-body-align">Rainbow Multipliers&reg;</div>
            <div class="trademarks-body-align">Raining Riches&reg;</div>
            <div class="trademarks-body-align">Record Breaker&reg;</div>
            <div class="trademarks-body-align">Reel Lock Progressives&reg;</div>
            <div class="trademarks-body-align">Reel Romance&reg;</div>
            <div class="trademarks-body-align">Repeating Win Multipliers&reg;</div>
            <div class="trademarks-body-align">Rise of the Nile&reg;</div>
            <div class="trademarks-body-align">Rise of the Pyramids&reg;</div>
            <div class="trademarks-body-align">Rocket City Bonanza&reg;</div>
            <div class="trademarks-body-align">Ruble Riches&reg;</div>
            <div class="trademarks-body-align">Sakura Tree&reg;</div>
            <div class="trademarks-body-align">Sally's Loot&reg;</div>
            <div class="trademarks-body-align">Santa's Elves&reg;</div>
            <div class="trademarks-body-align">Secrets of the Buddha&reg;</div>
            <div class="trademarks-body-align">Secrets of the Scarab&reg;</div>
            <div class="trademarks-body-align">Shadow Masquerade&reg;</div>
            <div class="trademarks-body-align">Shishenli&reg;</div>
            <div class="trademarks-body-align">Shocking Headlines&reg;</div>
            <div class="trademarks-body-align">Short Circuit&reg;</div>
            <div class="trademarks-body-align">Show Me Vegas&reg;</div>
            <div class="trademarks-body-align">Show Me Vegas Slots&reg;</div>
            <div class="trademarks-body-align">Showgirls Diamond&reg;</div>
            <div class="trademarks-body-align">Silver Buffalo&reg;</div>
            <div class="trademarks-body-align">Smelly Rich&reg;</div>
            <div class="trademarks-body-align">Snow Day!&reg;</div>
            <div class="trademarks-body-align">Solar Progressive&reg;</div>
            <div class="trademarks-body-align">Spitfire Sam&reg;</div>
            <div class="trademarks-body-align">Split Card&reg;</div>
            <div class="trademarks-body-align">St Patrick's Gold&reg;</div>
            <div class="trademarks-body-align">State Fair&reg;</div>
            <div class="trademarks-body-align">Sultan of Egypt&reg;</div>
            <div class="trademarks-body-align">Super Blocks&reg;</div>
            <div class="trademarks-body-align">Super Hot Roll&reg;</div>
            <div class="trademarks-body-align">Super Rich&reg;</div>
            <div class="trademarks-body-align">Super Wheel Mania&reg;</div>
            <div class="trademarks-body-align">Super Wheelmania Link&reg;</div>
            <div class="trademarks-body-align">Sweet Fruit&reg;</div>
            <div class="trademarks-body-align">Tale of Ten Powers&reg;</div>
            <div class="trademarks-body-align">Tales of the Legend Dairy&reg;</div>
            <div class="trademarks-body-align">The Great and Wonderful Polar Bear&reg;</div>
            <div class="trademarks-body-align">Tiger Dynasty&reg;</div>
            <div class="trademarks-body-align">Tiger Empire&reg;</div>
            <div class="trademarks-body-align">Toucan Tropics&reg;</div>
            <div class="trademarks-body-align">Trash for Cash Poker&reg;</div>
            <div class="trademarks-body-align">Treasure Fish&reg;</div>
            <div class="trademarks-body-align">Treasure Hold &amp; Respin&reg;</div>
            <div class="trademarks-body-align">Treasure Key&reg;</div>
            <div class="trademarks-body-align">Treasure Zone&reg;</div>
            <div class="trademarks-body-align">Treasures of the Sky&reg;</div>
            <div class="trademarks-body-align">Triple Big Wheel&reg;</div>
            <div class="trademarks-body-align">Triple Buddha&reg;</div>
            <div class="trademarks-body-align">Triple Draw Triple Pay&reg;</div>
            <div class="trademarks-body-align">Triple Hearts&reg;</div>
            <div class="trademarks-body-align">Triple Spitfire 7s&reg;</div>
            <div class="trademarks-body-align">Trophy Size&reg;</div>
            <div class="trademarks-body-align">Turquoise Princess&reg;</div>
            <div class="trademarks-body-align">Turquoise Riches&reg;</div>
            <div class="trademarks-body-align">Turtle Coast&reg;</div>
            <div class="trademarks-body-align">Ultimate Catch&reg;</div>
            <div class="trademarks-body-align">Ultimate Cats&reg;</div>
            <div class="trademarks-body-align">Ultimate Hot Roll&reg;</div>
            <div class="trademarks-body-align">Vegas City of Riches&reg;</div>
            <div class="trademarks-body-align">Vegas Race&reg;</div>
            <div class="trademarks-body-align">Vegas Voodoo&reg;</div>
            <div class="trademarks-body-align">VIP&reg;</div>
            <div class="trademarks-body-align">VIP Riches&reg;</div>
            <div class="trademarks-body-align">Waterfall Multipliers&reg;</div>
            <div class="trademarks-body-align">Wedding Party&reg;</div>
            <div class="trademarks-body-align">Welcome Home&reg;</div>
            <div class="trademarks-body-align">Wheelmania&reg;</div>
            <div class="trademarks-body-align">Wild Paths&reg;</div>
            <div class="trademarks-body-align">Wild Pinata&reg;</div>
            <div class="trademarks-body-align">Winner Winner Thanksgiving Dinner&reg;</div>
            <div class="trademarks-body-align">Wizard Riches&reg;</div>
            <div class="trademarks-body-align">Wolf Goddess&reg;</div>
            <div class="trademarks-body-align">Wolf Peak&reg;</div>
            <div class="trademarks-body-align">Wu Da Jiang&reg;</div>
            <div class="trademarks-body-align">Xuduo Zhufu&reg;</div>
            <div class="trademarks-body-align">Zeus' Gold&reg;</div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { EventBus } from '../utils/eventBus'
export default {
  name: 'Trademarks',
  methods: {
    okClicked () {
      EventBus.$emit('trademarksClicked')
    }
  }
}
</script>

<style lang="scss" scoped>
.trademarks-container {
  background-color: rgba(0,0,0,0.1);
}

.trademarks-title {
  font-family: museo-slab, serif;
  font-style: italic;
  font-weight: 700;
  font-size: 45px;
  color: #f6821f;
  letter-spacing: -1px;
}

.trademarks-subtitle {
  font-family: museo-slab, serif;
  font-style: normal;
  font-weight: 800;
  font-size: 20px;
  color: #335091;
}

.body-text {
  font-size: 18px;
}

.trademarks-body-title {
  font-family: museo-slab, sans-serif;
  font-style: normal;
  font-weight: 500;
  color: #335091;
  font-size: 24px;
}

.trademarks-body-list {
  font-family: museo-slab, sans-serif;
  font-style: normal;
  font-weight: 600;
  color: #335091;
  font-size: 18px;
}

.trademarks-body-align {
  text-align: left;
  margin-top: 5px;
}
</style>
